var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hicon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 17H13M20.989 10C21 10.577 21 11.2365 21 12C21 14.8003 21 16.2004 20.455 17.27C19.9757 18.2108 19.2108 18.9757 18.27 19.455C17.2004 20 15.8003 20 13 20H11C8.19974 20 6.79961 20 5.73005 19.455C4.78924 18.9757 4.02433 18.2108 3.54497 17.27C3 16.2004 3 14.8003 3 12C3 11.2365 3 10.577 3.01105 10M20.989 10C20.9595 8.46078 20.8514 7.50797 20.455 6.73005C19.9757 5.78924 19.2108 5.02433 18.27 4.54497C17.2004 4 15.8003 4 13 4H11C8.19974 4 6.79961 4 5.73005 4.54497C4.78924 5.02433 4.02433 5.78924 3.54497 6.73005C3.14859 7.50797 3.04052 8.46078 3.01105 10M20.989 10H3.01105",
    stroke: "#36d66b",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.678d5daa05333a3b3e522cd59eceea1e.svg";
export { ForwardRef as ReactComponent };